// extracted by css-extract-rspack-plugin
export default {"popover-wrapper":"E9EzjW","popoverWrapper":"E9EzjW","root":"atUXH4"};